import styles from "../nsc/NscDeliveryRanges.module.scss";
import { Grid } from "@material-ui/core";
import React from "react";
import Item from "../../../../shared/item/Item";

export const TableHeader = (props) => {
  return (
    <Grid
      container
      spacing={0}
      className={`${styles.divider} pagePaddingLeft pagePaddingRight`}
    >
      {props.headers.map((header, headerIdx) => (
        <Grid
          item
          xs={3}
          style={{ justifyContent: headerIdx > 0 && "flex-end" }}
          className={styles.rowHeader}
          key={headerIdx}
        >
          <div className={styles.headerWrap}>
            <Item value={header} />
          </div>
        </Grid>
      ))}
    </Grid>
  );
};
